import { apiSlice } from "services/apiSlice";

export const expenseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: ({ companyId }) => ({
        url: `expenses/companyId/${companyId}`,
        method: "GET",
      }),
      providesTags: ["Expense"],
    }),
    createExpense: builder.mutation({
      query: (expenseData) => ({
        url: "expenses",
        method: "POST",
        body: expenseData,
      }),
      invalidatesTags: ["Expense"],
    }),
    updateExpense: builder.mutation({
      query: ({ expenseId, companyId, body }) => {
        if (body instanceof FormData) {
          for (let [key, value] of body.entries()) {
            console.log(`[FormData] ${key}:`, value);
          }
        } else {
          console.log("Body:", body);
        }

        return {
          url: `expenses/companyId/${companyId}/expenseId/${expenseId}`,
          method: "PATCH",
          body,
        };
      },

      invalidatesTags: ["Expense"],
    }),
    deleteExpense: builder.mutation({
      query: ({ expenseId, companyId }) => ({
        url: `expenses/${expenseId}/companyId/${companyId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Expense"],
    }),
    getNextExpenseNumber: builder.query({
      query: () => "expenses/next-number",
      providesTags: ["Expense"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetExpensesQuery,
  useCreateExpenseMutation,
  useUpdateExpenseMutation,
  useDeleteExpenseMutation,
  useGetNextExpenseNumberQuery,
} = expenseApi;
